



























import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { QueryPatientEdu } from "@/api/pdOutPatient/pdEducation/pdPatientEdu";
import eduPreview from "../pdKnowledge/pdPreviousEducationPlay.vue";
import fileShow from "../pdKnowledge/fileShow.vue";
@Component({
    components: { eduPreview,fileShow },
})
export default class extends AbpBase {
    data: any = [];
    loading: boolean = false;
    totalCount: number = 0;
    showPreview: boolean = false;
    queryCondition = {
        page: 1,
        pageSize: 10,
        patientName: "",
        eduTimeStart: null,
        eduTimeEnd: null,
    };
    previewData: any = {};
    date: any = [];
    dateOptions = {
        shortcuts: [
            {
                text: "一周",
                value() {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                    return [start, end];
                },
            },
            {
                text: "一个月",
                value() {
                    const end = new Date();
                    const start = new Date(
                        end.getFullYear(),
                        end.getMonth() - 1,
                        end.getDate() - 1
                    );
                    return [start, end];
                },
            },
            {
                text: "三个月",
                value() {
                    const end = new Date();
                    const start = new Date(
                        end.getFullYear(),
                        end.getMonth() - 3,
                        end.getDate() - 1
                    );
                    return [start, end];
                },
            },
            {
                text: "一年",
                value() {
                    const end = new Date();
                    const start = new Date(
                        end.getFullYear() - 1,
                        end.getMonth(),
                        end.getDate() - 1
                    );
                    return [start, end];
                },
            },
            {
                text: "两年",
                value() {
                    const end = new Date();
                    const start = new Date(
                        end.getFullYear() - 2,
                        end.getMonth(),
                        end.getDate() - 1
                    );
                    return [start, end];
                },
            },
        ],
    };
    columns = [
        {
            title: "患者姓名",
            key: "patientName",
            width: 120,
        },
        {
            title: "宣教时间",
            key: "eduTimeStr",
            width: 200
        },
        {
            title: "宣教人",
            width: 120,
            key: "eduUserName",
        },
        {
            title: "宣教内容",
            key: "knowledgeName",
        },
        {
            title: "操作",
            width: 170,
            render: (h: any, p: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "10px",
                            },
                            on: {
                                click: () => {
                                    this.preview(p.row);
                                },
                            },
                        },
                        "预览"
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "10px",
                            },
                            on: {
                                click: () => {
                                    this.print(p.row);
                                },
                            },
                        },
                        "打印"
                    ),
                ]);
            },
        },
    ];

    pageChange(val: any) {
        this.queryCondition.page = val;
        this.getData();
    }

    query() {
        this.queryCondition.page = 1;
        this.getData();
    }

    async getData() {
        this.queryCondition.eduTimeStart = this.formatDate(this.date[0]);
        this.queryCondition.eduTimeEnd = this.formatDate(this.date[1]);
        this.loading = true;
        let res = await QueryPatientEdu(this.queryCondition);
        this.data = res.items;
        this.totalCount = res.totalCount;
        this.loading = false;
    }

    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        this.date = [start, end];
        this.getData();
    }

    viewData:any={};
     viewShow=false;
    preview(row: any) {
        this.viewData=row;
        this.viewShow = true;
        // this.previewData = {
        //     fileName: row.fileName,
        //     url: row.url,
        // };
        // this.showPreview = true;
    }

    print(row: any) {
        if (!row.url) {
            this.$Message.error("目前只能打印pdf格式的宣教资料");
            return;
        }
        let index = row.url.lastIndexOf(".");
        if (index == -1) {
            this.$Message.error("目前只能打印pdf格式的宣教资料");
            return;
        }
        let ext = row.url.substring(index, row.url.length).toLowerCase();
        if (ext != ".pdf") {
            this.$Message.error("目前只能打印pdf格式的宣教资料");
            return;
        }
        let url = `http://${location.hostname}:${SERVER_PORT}/${row.url}`;
        window.open(url);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEdu/query.vue